'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  angular.module('vnext').controller('InspirationsCtrl', InspirationsCtrl);

  InspirationsCtrl.$inject = ['$log', '$stateParams', 'inspirationSvc', 'mediaQuerySvc'];

  /* @ngInject */
  function InspirationsCtrl($log, $stateParams, inspirationSvc, mediaQuerySvc) {
    var vm = this;
    vm.title = 'InspirationsCtrl';
    vm.loading = false;
    vm.nextPage = nextPage;
    var _pageSize = mediaQuerySvc.getGridPageSize();

    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug('Inspirations control activate');
      inspirationSvc.clearCache();
      vm.inspirations = [];
      vm.type = $stateParams.type || 'new';

      nextPage();
    }

    function nextPage() {
      if (vm.loading) {
        return;
      }
      vm.loading = true;

      inspirationSvc.getNextPage($stateParams.type || 'new', _pageSize).then(function (newInspirations) {
        if (newInspirations) {
          var _vm$inspirations;

          (_vm$inspirations = vm.inspirations).push.apply(_vm$inspirations, _toConsumableArray(newInspirations));
        } else {
          vm.finished = true;
        }
        vm.loading = false;
      });
    }
  }
})();